module.exports = __webpack_public_path__ + "img/user-shown-icon.22692e5f.svg";